/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './detail';
import './summary';
import './custom_report';
import './settlements';
import './unsuccessful_payments';
import './cash_drawers';
import './product';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "BeemoExternalReportingServiceV2": {
                        "methods": {
                          "TransactionsReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.TransactionsReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.TransactionsReportResponse"
                          },
                          "LaborVsSalesSummary": {
                            "requestType": ".squareup.beemo.api.v2.reporting.LaborVsSalesSummaryRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.LaborVsSalesSummaryResponse"
                          },
                          "SectionSalesReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.SectionSalesReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.SectionSalesReportResponse"
                          },
                          "LaborAvailableFilters": {
                            "requestType": ".squareup.beemo.api.v2.reporting.AvailableFiltersRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.AvailableFiltersResponse"
                          },
                          "EmployeeSalesSummary": {
                            "requestType": ".squareup.beemo.api.v2.reporting.EmployeeSalesSummaryRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.EmployeeSalesSummaryResponse"
                          },
                          "SettlementReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.SettlementReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.SettlementReportResponse"
                          },
                          "SettlementReportLite": {
                            "requestType": ".squareup.beemo.api.v2.reporting.SettlementReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.SettlementReportLiteResponse"
                          },
                          "PendingSettlement": {
                            "requestType": ".squareup.beemo.api.v2.reporting.PendingSettlementRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.PendingSettlementResponse"
                          },
                          "PendingSettlements": {
                            "requestType": ".squareup.beemo.api.v2.reporting.PendingSettlementsRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.PendingSettlementsResponse"
                          },
                          "GetInvoiceSettlementReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.InvoiceSettlementReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.InvoiceSettlementReportResponse"
                          },
                          "CustomReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.CustomReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.CustomReportResponse"
                          },
                          "AvailableFilters": {
                            "requestType": ".squareup.beemo.api.v2.reporting.AvailableFiltersRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.AvailableFiltersResponse"
                          },
                          "GiftCardSummary": {
                            "requestType": ".squareup.beemo.api.v2.reporting.GiftCardSummaryRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.GiftCardSummaryResponse"
                          },
                          "OutstandingGiftCardReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.OutstandingGiftCardReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.OutstandingGiftCardReportResponse"
                          },
                          "UnsuccessfulPaymentsReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportResponse"
                          },
                          "CashDrawerShiftsReport": {
                            "requestType": ".squareup.beemo.api.v2.reporting.CashDrawerShiftsReportRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.CashDrawerShiftsReportResponse"
                          },
                          "ListCashDrawerShifts": {
                            "requestType": ".squareup.beemo.api.v2.reporting.ListCashDrawerShiftsRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.ListCashDrawerShiftsResponse"
                          },
                          "SplitDeposit": {
                            "requestType": ".squareup.beemo.api.v2.reporting.SplitDepositRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.SplitDepositResponse"
                          },
                          "GetPaymentUnit": {
                            "requestType": ".squareup.beemo.api.v2.reporting.GetPaymentUnitRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.GetPaymentUnitResponse"
                          },
                          "ListInvoiceMetadata": {
                            "requestType": ".squareup.beemo.api.v2.reporting.ListInvoiceMetadataRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.ListInvoiceMetadataResponse"
                          },
                          "GetProductUsage": {
                            "requestType": ".squareup.beemo.api.v2.reporting.GetProductUsageRequest",
                            "responseType": ".squareup.beemo.api.v2.reporting.GetProductUsageResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.BeemoExternalReportingServiceV2) {
  $root.addJSON(jsonData);
}

/**
 * The V2 Beemo External reporting endpoints.
 *
 * SOURCE BeemoExternalReportingServiceV2 @ squareup/beemo/v2/reporting/external.proto at 23:1
 */
export const BeemoExternalReportingServiceV2 = $root.lookupService('squareup.beemo.api.v2.reporting.BeemoExternalReportingServiceV2');